import { NetworkDispatcher } from "./Variable";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../react-core/Flux/BaseStore";
import { NetworkHistoryPaginatedModel } from "../../../../Wrap/Models/Models/Network/NetworkHistoryPaginatedModel";

export interface NetworkStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: NetworkHistoryPaginatedModel;
}

export class NetworkStoreStatic extends BaseStore<NetworkStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(NetworkDispatcher, (actionData) => this.onNetworkStoreResponse(actionData));
    }

    public getLastResult(): NetworkStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): NetworkStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onNetworkStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
